// extracted by mini-css-extract-plugin
export default {"gridContainer":"PreviewGrid_gridContainer__1Sny5","footer":"PreviewGrid_footer__ad3fo","recordCountWarning":"PreviewGrid_recordCountWarning__R9zfo"};